import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import dayjs from 'dayjs';
import styles from './ButtonUninstall1.module.less';

import { logging } from '../../../actions/log';
import { getLocalSoft } from '../../../actions/native';
import { downloadAddSoft } from '../../../actions/downloadTask';
import { setSIMPopupInfo } from '../../../actions/asimstatus';
import { fasterProductNextTime } from '../../../constants/storageKeys';
import { setFasterProduct, setMenuSpot } from '../../../actions/layout';
import { PCStoreJsBridge } from '../../../nativeapi';
import { mySoftKeys } from '../../../constants/storageKeys';
import Dialog from '../../Dialog/Dialog';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectDownloadSofts = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask.softs,
);

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);
const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSofts,
);

const selectIsSIMRunning = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.issimrunnings,
);
const selectSIMDowning = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.SIMDowning,
);

export default memo(
  ({
    soft,
    info = {},
    logInfo = {},
    isShowSpot = false,
    handleIsShowSpot = () => {},
    handleUninstall = () => {},
  }) => {
    let cn_sbutton = styles.sbutton;
    let cn_sbutton_busing = styles.sbutton_busing;
    let cn_sbutton_open = styles.sbutton_open;
    // 按钮info传入百分比进度颜色
    let dl_progressColor = info.progressColor || '#CAF3E1';
    // 按钮info传入百分比进度将要覆盖的背景颜色
    let dl_backgroundColor = info.backgroundColor || '#ffffff00';

    const dispatch = useDispatch();
    const logInfoData = useSelector(selectLogInfo);
    const downloadSofts = useSelector(selectDownloadSofts); // 正在下载
    const upgradeSofts = useSelector(selectUpgradeSofts); // 可更新
    const installedSofts = useSelector(selectInstalledSoft); // 已经安装
    const isSIMRunning = useSelector(selectIsSIMRunning); // 电脑模拟器是否正在运行
    const SIMDowning = useSelector(selectSIMDowning);

    const [fondSoft, setFondSoft] = useState(undefined);
    const [upgrade, setUpgrade] = useState(undefined);
    const [installed, setInstalled] = useState(undefined);
    const [linearGradient, setLinearGradient] = useState(
      `linear-gradient(to right, ${dl_progressColor} 0%, ${dl_backgroundColor} 0%)`,
    );
    const [buttonText, setButtonText] = useState(info.text || '打开');
    const [modalVisible, setModalVisible] = useState(false);

    const installRef = useRef();
    useEffect(() => {
      installRef.current = SIMDowning;
    });

    // 查询当前是否已经安装
    useEffect(() => {
      if (upgradeSofts) {
        const up = upgradeSofts.find(
          soft_ => soft_.androidType === '1' && soft_.packageName === soft.packageName,
        );
        setUpgrade(up);
      }
    }, [soft, upgradeSofts]);

    // 查询当前是否已经安装 并且是否可升级
    useEffect(() => {
      if (installedSofts) {
        const inst = installedSofts.find(
          soft_ => soft_.androidType === '1' && soft_.packageName === soft.packageName,
        );
        setInstalled(inst);
      }
    }, [soft, installedSofts]);

    // 更新按钮显示状态
    useEffect(() => {
      let linear_Gradient = `linear-gradient(to right, ${dl_backgroundColor} 0%, ${dl_backgroundColor} 0%)`;
      let button_Text = info.text || '打开';
      const found =
        downloadSofts &&
        downloadSofts.find(soft_ => soft_.type === 'apk' && soft_.apk.pkg === soft.packageName);

      if (found && found.apk && found.apk.pkg) {
        if (found.attr.status === 'pre') {
          button_Text = '准备中';
        } else if (found.attr.status === 'wait') {
          button_Text = '等待中';
        } else if (found.attr.status === 'pause') {
          button_Text = '继续';
          linear_Gradient = `linear-gradient(to right, ${dl_progressColor} ${found.attr.progress ||
            0}%, ${dl_backgroundColor} ${found.attr.progress || 0}%)`;
        } else if (found.attr.status === 'dl') {
          button_Text = `${
            found.attr && found.attr.progress ? found.attr.progress.toFixed(0) : 0
          }%`;
          linear_Gradient = `linear-gradient(to right, ${dl_progressColor} ${found.attr.progress ||
            0}%, ${dl_backgroundColor} ${found.attr.progress || 0}%)`;
        } else if (found.attr.status === 'i') {
          button_Text = '安装中';
          linear_Gradient = `linear-gradient(to right, ${dl_progressColor} 0%, ${dl_backgroundColor} 0%)`;
        } else if (found.attr.status === 'exitq') {
          // // 安装完成重新获取一次本地列表
          // dispatch(getLocalSoft());
        } else if (found.attr.status === 'err') {
        }
      } else if (installed) {
        button_Text = '打开';
      }

      if (buttonText !== button_Text) {
        setButtonText(button_Text);
      }
      if (linearGradient !== linear_Gradient) {
        setLinearGradient(linear_Gradient);
      }
      setFondSoft(found || undefined);
    }, [dispatch, soft, downloadSofts, upgrade, installed]);

    // 加速器
    const handelFaster = () => {
      const now = dayjs(Date.now()).format('YYYYMMDD');
      const nextPopTime = localStorage.getItem(fasterProductNextTime);
      if ((!nextPopTime || +now >= +nextPopTime) && soft && soft.appRecommend) {
        dispatch(
          setFasterProduct({
            soft,
            info,
            logInfo,
            record: true,
          }),
        );
      }
    };

    // 获取生成打桩参数
    // const getLogParam2 = useCallback(
    //   (soft_info, logInfo_para) => {
    //     const logParam2 = {
    //       source: logInfo_para.source,
    //       source_p: logInfoData.source_p,
    //       source_pp: logInfoData.source_pp,
    //       softid: soft_info.packageName,
    //       softName: soft_info.softName,
    //       packageName: soft_info.packageName,
    //       softType: '1', // 安卓(1)还是PC(0)应用
    //       type: upgrade ? 'u' : 'd', // 更新还是下载
    //       url: soft_info.downLoadUrl,
    //     };
    //     // 当为搜索结果也跳转过来的，带上附加信息
    //     if (logInfo_para.isSearch) {
    //       logParam2.search_type = logInfoData.search_type;
    //       logParam2.search_word = logInfoData.search_word;
    //       logParam2.lenovo_bizinfo = logInfo_para.lenovo_bizinfo || logInfoData.lenovo_bizinfo;
    //     }
    //     // 联想词softcard  做特殊处理 参数通过 logInfo (即logInfo_para) 传入
    //     if (
    //       logInfo_para.isSearch &&
    //       (logInfo_para.search_type === 4 ||
    //         logInfo_para.search_type === 5 ||
    //         logInfo_para.search_type === 6)
    //     ) {
    //       logParam2.source_p = logInfo_para.source_p;
    //       logParam2.source_pp = logInfo_para.source_pp;
    //       logParam2.search_type = logInfo_para.search_type;
    //       logParam2.search_word = logInfo_para.search_word;
    //       logParam2.lenovo_bizinfo = logInfo_para.lenovo_bizinfo || logInfoData.lenovo_bizinfo;
    //     }

    //     // 处理命令行直接跳入搜索结果页面没有search_word的问题
    //     if (logInfo_para.isSearch && logInfo_para.search_word) {
    //       logParam2.search_word = logInfo_para.search_word;
    //     }
    //     return logParam2;
    //   },
    //   [logInfoData, upgrade],
    // );

    const handleTipsModal = useCallback(softInfo => {
      PCStoreJsBridge.getIsSIMInstalled().then(SIMInstalled => {
        if (!SIMInstalled && !installRef.current) {
          dispatch(setSIMPopupInfo(softInfo));
        } else {
          handelFaster();
          dispatch(downloadAddSoft(softInfo));
        }
      });
    });

    const handleInstallSoft = useCallback(
      (soft_info, button_Text, logInfo_para, fond_soft) => {
        // const logParam2 = getLogParam2(soft_info, logInfo_para);
        // const logParam2 = {
        //   source: 'Mysofts',
        //   source_p: logInfoData.source_p,
        //   source_pp: logInfoData.source_pp,
        //   softid: soft_info.softID,
        //   softName: soft_info.softName,
        //   softType: 'o',
        //   url: soft_info.downLoadUrl || soft_info.downloadUrl,
        //   type: 'o',
        // };

        const logParam2 = {
          source: 'Mysofts',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: soft_info.packageName,
          softName: soft_info.softName,
          packageName: soft_info.packageName,
          softType: '1', // 安卓(1)还是PC(0)应用
          type: upgrade ? 'u' : 'd', // 更新还是下载
          url: soft_info.downLoadUrl,
        };

        let isNeedLog = false;
        const softInfo = { ...soft_info, logInfo: logParam2, isClick: 'click' };
        // 正常安装
        if (button_Text === '安装' || button_Text === '升级') {
          if (button_Text !== '安装' && button_Text !== '电脑安装' && button_Text !== '立即安装') {
            dispatch(downloadAddSoft(softInfo));
          } else {
            handleTipsModal(softInfo);
          }
          isNeedLog = true;
        }

        // // 正在下载中，点击暂停
        // if (fond_soft && fond_soft.attr && fond_soft.attr.status === 'dl') {
        //   logParam2.isPause = '1';
        //   PCStoreJsBridge.downloadPause({ ...fond_soft });
        //   isNeedLog = true;
        // }
        // 正在暂停中，点击继续
        if (fond_soft && fond_soft.attr && fond_soft.attr.status === 'pause') {
          logParam2.isPause = '0';
          PCStoreJsBridge.downloadResume({ ...fond_soft });
          isNeedLog = true;
        }
        if (button_Text === '打开') {
          logParam2.type = 'o';
          isNeedLog = true;

          // 首先判断模拟器是否已经安装。
          PCStoreJsBridge.getIsSIMInstalled().then(SIMInstalled => {
            if (SIMInstalled) {
              PCStoreJsBridge.openAndroidSoft({ ...soft_info, logInfo: logParam2 });
            } else {
              // 当不存在模拟器重新获取一次本地列表改变按钮的状态。
              dispatch(getLocalSoft());
            }
          });
        }

        // 展示取消小红点
        // 是否为第一次打开，取消小红点
        logParam2.type = '0';
        const spotSoftStr = localStorage.getItem(mySoftKeys.RED_SPOT_SOFT);
        const spotSoft = spotSoftStr && spotSoftStr.split(',');
        if (spotSoft && spotSoft.indexOf(softInfo.packageName) > -1) {
          spotSoft.splice(spotSoft.indexOf(softInfo.packageName), 1);
          localStorage.setItem(mySoftKeys.RED_SPOT_SOFT, spotSoft.join(','));
          handleIsShowSpot(false);
          logParam2.type = '1';
        }

        // 更新菜单上的小红点
        const spotSoftStrNew = localStorage.getItem(mySoftKeys.RED_SPOT_SOFT);
        const installedSpotSoft = installedSofts.find(
          softItem =>
            softItem.androidType === '1' &&
            spotSoftStrNew &&
            spotSoftStrNew.indexOf(softItem.packageName) > -1,
        );
        dispatch(setMenuSpot(installedSpotSoft && installedSpotSoft.packageName));

        // 按钮点击打桩
        if (isNeedLog) {
          dispatch(
            logging({
              category: 'C',
              action: 'Mysofts_Open',
              label: '',
              param2: logParam2,
              param3: soft_info.bizInfo || null,
            }),
          );
        }
      },
      [upgrade, installed],
    );

    const handleDownloadSoft = soft_info => {
      const logParam2 = {
        source: 'Mysofts_Fail_Open',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
        softid: soft_info.packageName,
        softName: soft_info.softName,
        packageName: soft_info.packageName,
        softType: '1', // 安卓(1)还是PC(0)应用
        type: upgrade ? 'u' : 'd', // 更新还是下载
        url: soft_info.downLoadUrl,
      };

      const softInfo = { ...soft_info, logInfo: logParam2 };
      dispatch(
        logging({
          category: 'C',
          action: 'Fail_Open_Reinstall',
          label: '',
          param2: {
            softid: soft_info.softID ?? soft_info?.SoftID ?? '',
            guid: soft_info?.softGUID,
            source: 'Mysofts_Fail_Open',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      dispatch(downloadAddSoft(softInfo));
    };

    return (
      <>
        <div
          style={
            fondSoft && fondSoft.attr && fondSoft.attr.status && linearGradient
              ? { backgroundImage: linearGradient }
              : {}
          }
          className={
            fondSoft && fondSoft.attr
              ? `${styles.button} ${cn_sbutton_busing} ${info.className_busing || ''}`
              : `${styles.button}
            ${cn_sbutton}
            ${info.className || ''}
            ${buttonText === '打开' && `${cn_sbutton_open} ${info && info.className_open}`}`
          }
          onClick={e => {
            e.preventDefault();
            handleInstallSoft(soft, buttonText, logInfo, fondSoft);
          }}
        >
          {buttonText}
        </div>
        {isShowSpot && <div className={styles.open_btn_spot} />}
        {/* {modalVisible && (
          <Dialog
            maskStyle={styles.mask}
            containerStyle={styles.force_delete}
            handleClose={() => setModalVisible(false)}
            title="温馨提示"
          >
            {soft?.packageName && (
              <>
                <div className={styles.message}>应用已无法打开，您可以卸载该应用或重新安装。</div>
                <div className={styles.btn_operation}>
                  <div
                    className={styles.btn}
                    onClick={() => {
                      handleUninstall();
                      setModalVisible(false);
                    }}
                  >
                    卸载
                  </div>
                  <div
                    className={styles.btn_create}
                    onClick={() => {
                      handleDownloadSoft(soft);
                      setModalVisible(false);
                    }}
                  >
                    重新安装
                  </div>
                </div>
              </>
            )}
            {!soft?.packageName && (
              <>
                <div className={styles.message}>该应用已无法打开，您可以卸载该应用。</div>
                <div className={styles.btn_operation}>
                  <div
                    className={styles.btn}
                    onClick={() => {
                      handleUninstall();
                      setModalVisible(false);
                    }}
                  >
                    卸载
                  </div>
                </div>
              </>
            )}
          </Dialog>
        )} */}
      </>
    );
  },
);
